import { createStore } from 'vuex'



export default createStore({
  state: { "Precios": {} },
  mutations: {

    seleccionarProductoParrilla (state, codigo) {

      state["ProductoSeleccionadoEnParrilla"] = codigo;

    },

    addAddonParrilla(state, codigo) {

      state["AddonsSeleccionados"].push(codigo);

    },

    resetAddonsParrilla(state, extensiones) {

      state["AddonsSeleccionados"] = extensiones;

    },

    resetPeriodoSeleccionado(state, periodo) {

      state["PeriodoSeleccionado"] = periodo;

    },

    ActualizarPreciosPresupuesto(state, Precios) {

      state["Precios"] = Precios;
      state["quotation"] = true;

    },

    ActualizarPrecioFinal(state, Precio) {

      state["PrecioFinal"] = Precio;

    },

    ActualizarNumeroAsegurados(state, NumeroAsegurados) {

      state["NumeroAsegurados"] = NumeroAsegurados;

    },

    ActualizarPricing(state, Pricing) {

      state["Pricing"]["products"] = Pricing;

    },

    ActualizarEmail(state, email) {

      state["email"] = email;

    },

    ActualizarNombreTomador(state, nombre) {

      state["nombreTomador"] = nombre;

    },

    ActualizarAsegurados(state, asegurados) {

      state["asegurados"] = asegurados;

    },

    ActualizarTipoTomador(state, tipo) {

      state["presupuestoTipo"] = tipo;

    },

    ActualizarIdPresupuesto(state, id) {

      state["idPresupuesto"] = id;

    },

    ActualizarNavbar(state, navbar) {

      state["Header"]["navbar"] = navbar;

    },

    CambiarCargando(state, navbar) {

      state["cargando"] = navbar;

    },


    CambiarDiasPromoDinamica(state, dias) {

      state["DiasPromoAmazon"] = dias;

    },

    ImportarDatosEstado(state, datos) {

      for (let numero of Object.keys(datos))
      {

          state[numero] = datos[numero];      

      }
    }


  },
  actions: {

    async getDataJson({commit}, url) {

      try {

        var axios = require('axios');

        let Datos = await axios(
            {
                method: 'get',
                url: url,
                config: { headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json' 
                  }}
            }
        );

        let datos = await Datos.data;

        commit('ImportarDatosEstado', datos)

        return Datos.data;
        
      } catch (error) {

          let retorno = {"status" : "KO", "message" : error};
          return retorno;
          
      }

    },


  },
  modules: {
  }
})
